/**
 * Cookiebot marketing-consent helpers.
 * Cookiebot may load via GTM; window.Cookiebot is often not ready on first paint.
 */

export const hasMarketingConsent = () =>
  Boolean(window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.marketing);

/**
 * Runs cb once marketing consent is known/granted, and again when the user accepts.
 * @param {() => void} cb
 * @returns {() => void} cleanup
 */
export const onMarketingConsent = cb => {
  const run = () => {
    if (hasMarketingConsent()) {
      cb();
    }
  };

  if (window.Cookiebot && window.Cookiebot.consent) {
    run();
  }

  window.addEventListener('CookiebotOnConsentReady', run);
  window.addEventListener('CookiebotOnAccept', run);

  return () => {
    window.removeEventListener('CookiebotOnConsentReady', run);
    window.removeEventListener('CookiebotOnAccept', run);
  };
};

/** @returns {boolean} whether a consent banner can be reopened at all */
export const canRenewConsent = () =>
  Boolean(window.Cookiebot && typeof window.Cookiebot.renew === 'function');

/**
 * Reopens the Cookiebot banner so the guest can change or withdraw consent.
 * This is our replacement for Cookiebot's floating privacy-trigger badge, which
 * is disabled so it cannot cover UI in the bottom corners — consent still has
 * to be as easy to withdraw as it was to give, just from a link rather than a
 * permanent bubble.
 * @returns {boolean} whether the banner was reopened
 */
export const renewConsent = () => {
  if (!canRenewConsent()) return false;
  window.Cookiebot.renew();
  return true;
};
